import type { ReactNode } from "react";

type C1DefinitionIconResolver = (iconDefinitionId: string) => ReactNode | undefined;

let definitionIconResolver: C1DefinitionIconResolver | undefined;

/** Shared image lookup for group icons in both the navigator and SVG plans. */
export function getC1EloDefinitionIconUrl(definition: { icon?: string } | undefined): string | undefined {
  const icon = definition?.icon;
  if (!icon?.startsWith("image:")) return undefined;
  return state.hostBaseUrl + icon.slice("image:".length);
}

/** Installs the UI registry lookup without introducing a module dependency cycle. */
export function setC1EloDefinitionIconResolver(resolver: C1DefinitionIconResolver): void {
  definitionIconResolver = resolver;
}

/**
 * Resolves the shared palette icon for an ELO catalog definition.
 *
 * The JSON catalog selects a shared furniture definition or `image:` asset path by its `icon` ID.
 * All consumers therefore render the same registered icon without knowing
 * anything about specific ELO item types.
 */
export function getC1EloDefinitionIcon(definition: { icon?: string } | undefined): ReactNode | undefined {
  const iconDefinitionId = definition?.icon;
  if (!iconDefinitionId) return undefined;
  if (iconDefinitionId.startsWith("image:")) {
    const src = getC1EloDefinitionIconUrl(definition);
    const size = iconDefinitionId === "image:images/consumer/DoorStation.png" ? "70%" : "80%";
    return src ? <img src={src} alt="" style={{ width: size, height: size, objectFit: "contain" }} /> : undefined;
  }
  return definitionIconResolver?.(iconDefinitionId);
}
